var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"purchasing-unit-label"},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.statusLabel)?_c('b-tag',{staticClass:"ml-1",attrs:{"size":"is-small","type":_vm.statusType}},[_vm._v(_vm._s(_vm.statusLabel))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }